const InsuredData = ({
  Name,
  Document,
  DocumentNumber,
  PolicyHolder,
  Address,
  address,
}) => ({
  name: Name ?? '',
  document: Document ?? '',
  documentNumber: DocumentNumber ?? '',
  policyHolder: PolicyHolder ?? '',
  cep: Address?.cep ?? address?.cep ?? '',
  place: Address?.place ?? address?.place ?? '',
  number: Address?.number ?? address?.number ?? '',
  complement: Address?.complement ?? address?.complement ?? '',
  district: Address?.district ?? address?.district ?? '',
  city: Address?.city ?? address?.city ?? '',
  state: Address?.state ?? address?.state ?? '',
})

export default InsuredData
